module.exports = __webpack_public_path__ + "static/pegi-e4e56fb716d6920977d0d3d3ec407664.png";